import { ofType } from 'redux-observable'
import { ignoreElements, take, tap } from 'rxjs/operators'
import * as Actions from 'store/actions/index.ts'
import { getCountryCode, getPartner } from 'store/selectors'

const faviconsURI = {
  EBT: {
    DE: '//www.veepee.de/favicon.ico',
    FR: '//www.veepee.fr/favicon.ico'
  },
  PRV: {
    ES: '//es.privalia.com/gr/icons/privalia/favicon.ico',
    IT: '//it.privalia.com/gr/icons/privalia/favicon.ico'
  },
  VEX: {
    BE: '//shop.veepee.be/favicon.ico',
    LU: '//shop.veepee.lu/favicon.ico',
    NL: '//shop.veepee.nl/favicon.ico'
  },
  VP: {
    AT: '//www.veepee.at/favicon.ico',
    DE: '//www.veepee.de/favicon.ico',
    ES: '//www.veepee.es/favicon.ico',
    FR: '//www.veepee.fr/favicon.ico',
    IT: '//www.veepee.it/favicon.ico'
  }
}

const DEFAULT_FAVICON_URI = 'favicons/favicon.ico'

const faviconEpic = (actions$, state$) =>
  actions$.pipe(
    ofType(Actions.member.MEMBER_INFO_FETCHED),
    take(1),
    tap(() => {
      const country = getCountryCode(state$.value)
      const partner = getPartner(state$.value)
      const uri = (faviconsURI[partner] && faviconsURI[partner][country])
        ? faviconsURI[partner][country]
        : DEFAULT_FAVICON_URI

      const faviconElem = document.getElementById('favicon')
      faviconElem.setAttribute('href', uri)
      faviconElem.setAttribute('rel', 'icon')
    }),
    ignoreElements()
  )

export default faviconEpic
